"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = require("react");
const ChartContext_1 = require("../context/ChartContext");
function useNucleus() {
    const { view: { spectra: { activeSpectra }, }, } = (0, ChartContext_1.useChartData)();
    return (0, react_1.useMemo)(() => {
        if (activeSpectra && Object.keys(activeSpectra).length > 0) {
            return Object.keys(activeSpectra);
        }
        return [];
    }, [activeSpectra]);
}
exports.default = useNucleus;
